import { render, staticRenderFns } from "./DefaultLayoutEn.vue?vue&type=template&id=5d1786b9&"
import script from "./DefaultLayoutEn.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutEn.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayout.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports